import { render, staticRenderFns } from "./MyInvest.vue?vue&type=template&id=ed6e30cc&scoped=true&"
import script from "./MyInvest.vue?vue&type=script&lang=js&"
export * from "./MyInvest.vue?vue&type=script&lang=js&"
import style0 from "./MyInvest.vue?vue&type=style&index=0&id=ed6e30cc&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ed6e30cc",
  null
  
)

export default component.exports